export function isIosSafariBrowser() {
  const ua = window.navigator.userAgent || '';
  const platform = window.navigator.platform || '';
  const maxTouchPoints = window.navigator.maxTouchPoints || 0;

  const isIosDevice =
    /iPhone|iPad|iPod/i.test(ua) ||
    (platform === 'MacIntel' && maxTouchPoints > 1);
  const isWebkitSafari =
    /Safari/i.test(ua) &&
    !/CriOS|FxiOS|EdgiOS|OPiOS|mercury|GSA|DuckDuckGo/i.test(ua);

  return isIosDevice && isWebkitSafari;
}

export function formatVideoTime(totalSeconds) {
  const safe = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;

  if (hours > 0) {
    return [hours, minutes, seconds]
      .map(value => String(value).padStart(2, '0'))
      .join(':');
  }

  return [minutes, seconds]
    .map(value => String(value).padStart(2, '0'))
    .join(':');
}

export function getDocumentFullscreenElement() {
  return document.fullscreenElement || document.webkitFullscreenElement || null;
}

export function isVideoInIosNativeFullscreen(videoEl) {
  return !!videoEl?.webkitDisplayingFullscreen;
}

export function isVideoInFullscreen(videoEl, shellEl) {
  const fullscreenEl = getDocumentFullscreenElement();

  return !!(
    (fullscreenEl &&
      (fullscreenEl === shellEl ||
        fullscreenEl === videoEl ||
        shellEl?.contains?.(fullscreenEl))) ||
    isVideoInIosNativeFullscreen(videoEl) ||
    videoEl?.webkitPresentationMode === 'fullscreen'
  );
}
